import { render, staticRenderFns } from "./HiddenButton.vue?vue&type=template&id=5619425c&"
import script from "./HiddenButton.vue?vue&type=script&lang=js&"
export * from "./HiddenButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports